import React from "react";
import { List, Popover, Space, Typography } from "antd";
import "./truncatedlistwithpopover.css";

const TruncatedListWithPopover = ({
  dataList,
  dataToBeDisplayed,
  direction,
}) => {
  const remainingCount = dataList?.length - dataToBeDisplayed;
  const remainingServices = dataList
    ?.slice(dataToBeDisplayed)
    .map((item) => item);
  return (
    <div className="truncatedListWithPopover">
      <Space direction={direction} size="small">
        {dataList?.slice(0, dataToBeDisplayed).map((item, index) => {
          const isLastElement = index === dataToBeDisplayed - 1;

          return (
            <div key={index}>
              {item}
              {!isLastElement && remainingCount > 0 && ","}
              {isLastElement && remainingCount > 0 && (
                <Popover
                  overlayClassName="popover-helpertext"
                  placement="top"
                  content={
                    <List
                      dataSource={remainingServices}
                      renderItem={(service) => (
                        <Typography>{service}</Typography>
                      )}
                    />
                  }
                  trigger={["click"]}
                >
                  <span className="remainingCount"> +{remainingCount}</span>
                </Popover>
              )}
            </div>
          );
        })}
      </Space>
    </div>
  );
};

export default TruncatedListWithPopover;
